import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useVehicles } from '../hooks/useVehicles';

const CATEGORIES = [
  'Motor & Şanzıman','Fren Sistemi','Süspansiyon',
  'Elektrik & Elektronik','Kaporta & Karoser',
  'Klima & Soğutma','Egzoz Sistemi','Yakıt Sistemi','Aydınlatma','İç Donanım',
];

const YEARS = Array.from({ length: 20 }, (_, i) => String(2024 - i));

const sel = 'w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm bg-white focus:outline-none focus:border-blue-600 transition text-gray-700';

const SearchBox = ({ onSearch }) => {
  const navigate = useNavigate();
  const { brands, models } = useVehicles();
  const [form, setForm] = useState({ brand:'', model:'', year:'', category:'', partName:'' });

  const set = (f, v) => setForm(p => ({ ...p, [f]: v, ...(f === 'brand' ? { model:'' } : {}) }));

  const handleSubmit = () => {
    if (!form.brand || !form.model || !form.year) {
      alert('Lütfen marka, model ve yıl seçin.');
      return;
    }
    if (onSearch) onSearch(form);
    navigate('/request', { state: form });
  };

  return (
    <div className="bg-white rounded-2xl shadow-2xl p-6 max-w-2xl mx-auto">
      <h3 className="text-sm font-semibold text-gray-700 mb-4">Parça Ara</h3>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-3">
        <select className={sel} value={form.brand} onChange={e => set('brand', e.target.value)}>
          <option value="">Marka Seçin</option>
          {brands.map(b => <option key={b}>{b}</option>)}
        </select>
        <select className={sel} value={form.model} onChange={e => set('model', e.target.value)} disabled={!form.brand}>
          <option value="">Model Seçin</option>
          {(models[form.brand] || []).map(m => <option key={m}>{m}</option>)}
        </select>
        <select className={sel} value={form.year} onChange={e => set('year', e.target.value)}>
          <option value="">Yıl Seçin</option>
          {YEARS.map(y => <option key={y}>{y}</option>)}
        </select>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-4">
        <select className={sel} value={form.category} onChange={e => set('category', e.target.value)}>
          <option value="">Parça Kategorisi</option>
          {CATEGORIES.map(c => <option key={c}>{c}</option>)}
        </select>
        <input
          type="text"
          className={sel}
          placeholder="Parça adı veya OEM no..."
          value={form.partName}
          maxLength={100}
          onChange={e => set('partName', e.target.value)}
        />
      </div>
      <button
        onClick={handleSubmit}
        className="w-full bg-blue-700 hover:bg-blue-800 text-white font-semibold py-3 rounded-lg text-sm transition"
      >
        Parça Ara & Teklif Al
      </button>
    </div>
  );
};

export default SearchBox;